<template lang="pug">
  b-modal#updateProfile(
    ref="updateProfile"
    :title="$t('ui.combine.edit_profile')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    size="md"
    @ok="done"
    @show="reset"
    @shown="shown"
  )
    b-form(novalidate :disabled="!submission.success" @submit.stop.prevent="submit")
      .form-group
        label {{ $t("ui.account_id") }}
        DebounceInput(
          type="text"
          ref="account_id"
          :placeholder='$t("ui.account_id")'
          :value="accountId.toUpperCase()"
          readonly
        )
      .form-group
        label {{ $t("ui.full_name") }}
        DebounceInput(
          type="text"
          ref="full_name"
          :dirty="$v.full_name.$dirty"
          :error="$v.full_name.$error"
          :placeholder='$t("ui.full_name")'
          v-model.trim.lazy="$v.full_name.$model"
          :maxLength="$v.full_name.$params.maxLength.max"
          :disabled="loading"
        )
        ValidateResult(:value="$v.full_name" :name="$t('ui.full_name')")
      .form-group
        label {{ $t("ui.contact_phone") }}
        DebounceInput(
          type="text"
          ref="contact_phone"
          :dirty="$v.contact_phone.$dirty"
          :error="$v.contact_phone.$error"
          :placeholder='$t("ui.contact_phone")'
          v-model.trim.lazy="$v.contact_phone.$model"
          :maxLength="$v.contact_phone.$params.maxLength.max"
          :disabled="loading"
        )
        ValidateResult(:value="$v.contact_phone" :name="$t('ui.contact_phone')")
      .form-group(v-if="accountSystemType.toUpperCase() == 'CREDIT'")
        MoneyInput(
          ref="credit_limit"
          :dirty="$v.credit_limit.$dirty"
          :error="$v.credit_limit.$error"
          :placeholder='$t("ui.credit_limit")'
          v-model="$v.credit_limit.$model"
          :title="title_credit_limit"
          :disabled="loading"
        )
        ValidateResult(:value="$v.credit_limit" :name="$t('ui.credit_limit')")
      .form-group(v-if="$helpers.isAgentLevel() && !$store.getters.cashMode")
        label.mr-1 {{ $t("ui.accumulate_win") }}
        i.fa.fa-info-circle(aria-hidden="true" :title='$t("message.accumulate_alert")')
        b-input-group
          b-form-input(
            type="text"
            ref="accumulate_win"
            :placeholder="this.$t('ui.accumulate_win')"
            v-model="accumulate_win"
            readonly
            size="sm"
          )
          b-input-group-append
            SubmitButton(:loading="loading" variant="warning" icon="fa fa-sync" :text="$t('ui.reset')" isModal=false type="button" size="sm" @click="resetWin")
      .form-group(v-if="!$helpers.isAgentLevel() && accountSystemType.toUpperCase() == 'CREDIT'")
        MoneyInput(
          ref="member_credit_limit"
          :dirty="$v.member_credit_limit.$dirty"
          :error="$v.member_credit_limit.$error"
          :placeholder='$t("ui.member_credit_limit")'
          v-model="$v.member_credit_limit.$model"
          :title="title_member_credit_limit"
          :disabled="loading"
        )
        ValidateResult(:value="$v.member_credit_limit" :name="$t('ui.member_credit_limit')")
      .form-group(v-if="$store.getters.accountType == 7")
        MoneyInput(
          ref="downline_limit"
          :dirty="$v.downline_limit.$dirty"
          :error="$v.downline_limit.$error"
          :placeholder='$t("ui.downline_limit")'
          v-model="$v.downline_limit.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.member_credit_limit" :name="$t('ui.member_credit_limit')")
      .form-group(v-if="$helpers.isAgentLevel() && !$store.getters.cashMode")
        label {{ $t("ui.win_limit") }}
        b-form-select(
          size="sm"
          v-model.trim.lazy="$v.win_limit.$model"
        )
          option(value="0") {{ $t("ui.win_limit_0") }}
          option(value="1") {{ $t("ui.win_limit_1") }}
          option(value="2") {{ $t("ui.win_limit_2") }}
          option(value="5") {{ $t("ui.win_limit_5") }}
          option(value="10") {{ $t("ui.win_limit_10") }}
          option(value="20") {{ $t("ui.win_limit_20") }}
        small.text-muted.text-danger.mr-1 {{ $t("ui.win_limit_tooltips") }}
        i.fa.fa-info-circle(aria-hidden="true" :title='$t("ui.win_limit_tooltips1")')
        ValidateResult(:value="$v.win_limit" :name="$t('ui.win_limit')")
      .form-group(v-if="$helpers.isAgentLevel() && !$store.getters.cashMode")
        label.mb-2 {{ $t('ui.daily_reset') }}
        br
        label.switch.switch-label.switch-success
          input(type="checkbox" class="switch-input" v-model="daily_reset" :disabled="loading")
          span(class="switch-slider" :data-checked="$t('ui.on')" :data-unchecked="$t('ui.off')")
      //- .form-group(v-if="!$helpers.isAgentLevel()")
      //-   label {{ $t('ui.payment_option') }}
      //-   b-form-checkbox-group(
      //-     ref="payment_option"
      //-     :class="{ 'is-invalid': $v.payment_option.$dirty == true && $v.payment_option.$error == true, 'is-valid': $v.payment_option.$dirty == true && $v.payment_option.$error == false }"
      //-     v-model.trim.lazy="$v.payment_option.$model"
      //-     :disabled="loading"
      //-     :options="isDayEnabledList"
      //-   )
      //-   ValidateResult.text-left(:value="$v.payment_option" :name="$t('ui.payment_option')")
      .form-group
        b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minValue, maxValue, minLength, maxLength, email, numeric, requiredIf } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import MoneyInput from "@/library/MoneyInput2";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    MoneyInput
  },
  props: {
    accountId: "",
    accountType: "",
    accountSystemType: ""
  },
  data() {
    return {
      loading: false,
      full_name: "",
      contact_phone: "",
      contact_email: "",
      currency: this.$store.getters.getAccountCurrency,
      credit_limit: "0",
      member_credit_limit: "0",
      win_limit: "0",
      downline_limit: "0",
      daily_reset: 0,
      selected_credit_limit: 0,
      accumulate_win: 0,
      payment_option: [],
      schJSON: {
        monday: true,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false
      },
      submission: {
        success: true,
        status: ""
      },
      days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
      schedule_list: null
    }
  },
  validations: {
    full_name: {
      // minLength: minLength(6),
      maxLength: maxLength(50)
    },
    contact_phone: {
      minLength: minLength(9),
      maxLength: maxLength(20)
    },
    // contact_email: {
    //   email,
    //   maxLength: maxLength(100)
    // },
    // currency: {
    //   required
    // },
    credit_limit: {
      required : requiredIf(function () {
        return this.accountSystemType.toUpperCase() == 'CREDIT';
      }),
      // numeric,
      maxValue(value) {
        if (!this.$helpers.isAgentLevel()) {
          return maxValue(this.max_credit_limit)(value)
        } else {
          return maxValue(this.max_member_credit_limit)(value)
        }
      }
    },
    member_credit_limit: {
      required : requiredIf(function (value) {
        if (this.accountSystemType.toUpperCase() == 'CREDIT')
          return !this.$helpers.isAgentLevel() ? required(value) : true;
        else
          return false;
      }),
      // required(value) {
      //   return (!this.$helpers.isAgentLevel()) ? required(value) : true
      // },
      maxValue(value) {
        let result = value
        if (result > this.max_member_credit_limit) {
          result = this.max_member_credit_limit
        }
        if (result > this.credit_limit) {
          result = this.credit_limit
        }
        return maxValue(result)(value)
      }
    },
    downline_limit: {
      required : requiredIf(function () {
        return this.$store.getters.accountType == 7;
      }),
      numeric,
    },
    win_limit: {
      required(value) {
        return (this.$helpers.isAgentLevel() && this.$store.getters.isLivecasinoPlatformEnabled) ? required(value) : true
      }
    },
    payment_option: {
      required(value) {
        return (!this.$helpers.isAgentLevel()) ? required(value) : true
      }
    }
  },
  computed: {
    isDayEnabled() {
      return this.$helpers.isDayEnabled();
    },
    isDayEnabledList() {
      return this.$helpers.isDayEnabledList();
    },
    title_credit_limit: function() {
      if (!this.$helpers.isAgentLevel()) {
        return this.$t("ui.max") + " = " + this.$helpers.numberFormat(this.max_credit_limit)
      } else {
        return this.title_member_credit_limit
      }
    },
    max_credit_limit: function(){
      return this.$store.getters.getAccountCreditLimit - this.$store.getters.getCreditUsedDownline + this.selected_credit_limit
    },
    title_member_credit_limit: function() {
      return this.$t("ui.max") + " = " + this.$helpers.numberFormat(this.max_member_credit_limit)
    },
    max_member_credit_limit: function(){
      return this.$store.getters.getAccountMemberCreditLimit
    }
  },
  mounted: function() {},
  methods: {
    getSchedule: function() {
      let member_id = this.accountId
      let client_ip = this.$helpers.getClientIP()
      this.loading = true
      if(member_id) {
        this.$store
          .dispatch("user/getSchedule", { member_id, client_ip })
          .then(response => {
            console.log(response)
            this.loading = false
            this.schedule_list = response.data;
          })
          .catch(response => {
            console.log("Failed:getSchedule", response)
            this.loading = false
          });
      } else {
        this.cancel()
      }
    },
    getEnabledList: function() {
      let result = [];
      let list = this.schedule_list;
      let dArr = this.days;
      if (list) {
        for (let count = 1; count < 8; count++) {
          let isEnabled = list.Table[0][dArr[count - 1]];
          if (isEnabled == true) {
            result.push({
              value: dArr[count - 1],
              text: this.$helpers.getDayName(count),
              disabled: count == 1 ? true : false
            });
          }
        }
      }
      // console.log(result)
      return result;
    },
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault();
      }
    },
    done: function(evt) {
      evt.preventDefault()
      this.submit()
    },
    formScheduleJson: function() {
      let allRefs = this.payment_option
      for (let i in this.schJSON) {
        if(i == "monday") {
          this.schJSON[i] = true;
        } else {
          this.schJSON[i] = false;
        }
      }
      for(let i=0;i<allRefs.length;i++){
        this.schJSON[allRefs[i]] = true
      }
    },
    resetWin: function() {
      let member_id = this.accountId
      this.loading = true
      this.$swal({
        title: this.$t("ui.status"),
        text: this.$t("message.reset_accumulate_win_confirm"),
        type: "warning",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("user/resetWin", { member_id })
            .then(response => {
              this.loading = false
              this.$swal({
                title: this.$t("ui.succeed"),
                text: this.$t("message.reset_accumulate_win_success"),
                type: "success",
                allowOutsideClick: false
              }).then(isConfirm => {
                if (isConfirm) {
                  this.cancel();
                }
              });
            })
            .catch(response => {
              this.loading = false
              this.$swal({
                title: this.$t("ui.succeed"),
                text: this.$t("message.reset_accumulate_win_cancel"),
                type: "error",
                allowOutsideClick: false
              }).then(isConfirm => {
                if (isConfirm) {
                  this.cancel();
                }
              });
            });
        } else if (
          // Read more about handling dismissals
          result.dismiss === 'cancel'
        ) {
          this.loading = false
          this.$swal({
            title: this.$t("ui.cancel"),
            text: this.$t("message.reset_accumulate_win_cancel"),
            type: "error",
            allowOutsideClick: false
          }).then(isConfirm => {
            if (isConfirm) {
              this.cancel();
            }
          });
        }
      });
    },
    getAccountDetails: function() {
      let account_id = this.accountId
      this.loading = true
      if(account_id) {
        this.$store
          .dispatch("user/getAccountDetails", { account_id })
          .then(response => {
            this.loading = false
            this.full_name = response.data.account_profile[0].full_name
            this.contact_phone = response.data.account_profile[0].contact_phone
            this.contact_email = response.data.account_profile[0].contact_email
            this.selected_credit_limit = response.data.account_wallet[0].credit_limit
            this.credit_limit = response.data.account_wallet[0].credit_limit != null ? response.data.account_wallet[0].credit_limit.toString() : response.data.account_wallet[0].credit_limit
            this.member_credit_limit = response.data.account_wallet[0].member_credit_limit != null ? response.data.account_wallet[0].member_credit_limit.toString() : "0"
            // this.member_credit_limit = response.data.account_wallet[0].member_credit_limit != null ? response.data.account_wallet[0].member_credit_limit.toString() : response.data.account_wallet[0].member_credit_limit
            this.win_limit = (response.data.account_wallet[0].win_limit) ? response.data.account_wallet[0].win_limit / response.data.account_wallet[0].credit_limit : this.win_limit
            this.daily_reset = (response.data.account_wallet[0].daily_reset) ? 1 : 0
            this.accumulate_win = (response.data.account_wallet[0].accumulate_win) ? response.data.account_wallet[0].accumulate_win : this.accumulate_win

            this.downline_limit = response.data.account_wallet[0].downline_limit != null ? response.data.account_wallet[0].downline_limit.toString() : response.data.account_wallet[0].downline_limit

            if(this.accountType != "1") {
              if(response.data.settlement_schedule.length > 0) {
                let dArr = this.days;
                for(let count = 1; count < 8; count ++) {
                  let day = dArr[count - 1]
                  if(response.data.settlement_schedule[0][day] == true) {
                    this.payment_option.push(day)
                  }
                }
              }
            }

            this.$v.$touch();
          })
          .catch(response => {
            console.log("Failed:getAccountDetails", response)
            this.loading = false
          });
      } else {
        this.cancel()
      }
    },
    submit: function() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.update_account_profile_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.updateAccountDetails()
          } else if (
            // Read more about handling dismissals
            result.dismiss === 'cancel'
          ) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.update_account_profile_cancel"),
              type: "error",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        });
      }
    },
    updateAccountDetails: function() {
      this.formScheduleJson()
      let member_id = this.accountId
      let full_name = this.full_name
      let contact_phone = this.contact_phone
      let contact_email = this.contact_email
      let credit_limit = this.credit_limit
      let member_credit_limit = this.member_credit_limit
      let win_limit_multiplier = this.win_limit
      let daily_reset = this.daily_reset ? 1 : 0
      let downline_limit = this.downline_limit
      let payment = this.schJSON
      this.$store
        .dispatch("user/updateAccountDetails", { member_id, full_name, contact_phone, contact_email, credit_limit, member_credit_limit, win_limit_multiplier, daily_reset, payment, downline_limit })
        .then(response => {
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if(this.submission.success == true) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.succeed"),
              text: this.$t("message.update_account_profile_success"),
              type: "success",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        })
        .catch(response => {
          console.log("Failed:updateAccountProfile", response)
          this.loading = false;
          if((typeof response.errorTag) != 'object') {
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
          }
        });
    },
    reset: function() {
      this.submission.success = true
      this.submission.status = ""
      this.full_name = ""
      this.contact_phone = ""
      this.contact_email = ""
      this.credit_limit = "0"
      this.member_credit_limit = "0"
      this.accumulate_win = 0
      this.win_limit = "0"
      this.daily_reset = 0
      this.payment_option = ["monday"]
    },
    shown: function() {
      this.$nextTick(() => {
        this.$v.$reset();
        this.$helpers.getCreditLimit(this.$store.getters.accountID, this.$store.getters.accountType)
        // if (!this.$helpers.isAgentLevel())
        //   this.getSchedule()
        this.$helpers.getSchedule()
        this.$helpers.getWallet()
        this.getAccountDetails()
      });
    },
    cancel: function() {
      this.$emit("clicked")
      this.$refs.updateProfile.hide()
    }
  }
}
</script>